import { BooleanSearchKeywordsModel } from './boolean-search-keywords.model';
import { MonitoringKeywordGroupModel } from './monitoring-keyword-group.model';
import { MediaTypeRequest } from './media-subscription.model';

interface MediaSubscriptionKeywordApi {
    mustTerms: string[];
    shouldTerms: string[];
    mustNotTerms: string[];
    mediaTypeRequests: MediaTypeRequest[];

    /** @deprecated use {@link mediaTypeRequests} */
    handles: string[];
    isAgent: boolean;
}

export class MediaSubscriptionKeywordsModel extends BooleanSearchKeywordsModel {
    handles: string[];

    constructor(apiEntity?: MediaSubscriptionKeywordApi) {
        super();


        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
    * Gets a simple version of this object with no methods
    */
    public getSimpleObject(): Object {
        const simpleObject: Object = {
            and: this.and,
            or: this.or,
            not: this.not,
            handles: this.handles
        };

        return simpleObject;
    }

    /**
    * Checks to see if there are any keywords
    * that should be included based on the field type
    */
    public hasIncludeKeywords(): boolean {
        const hasAndWords: boolean = this.hasKeywordsOfType(this.and);
        const hasOrWords: boolean = this.hasKeywordsOfType(this.or);
        const hasIncludeWords: boolean = hasAndWords || hasOrWords;

        return hasIncludeWords;
    }

    /**
    * Checks to see if there are any keywords
    * that should be excluded based on the field type
    */
    public hasExcludeKeywords(): boolean {
        const hasNotWords: boolean = this.hasKeywordsOfType(this.not);
        const hasExcludeWords: boolean = hasNotWords;

        return hasExcludeWords;
    }

    public equals(other: MediaSubscriptionKeywordsModel, checkHandles: boolean = true) {
        const arrayFields = [
            'and',
            'or',
            'not',
            // @TODO 'searchContexts',
            'handles'
        ];

        if (checkHandles) {
            arrayFields.push('handles');
        }

        for (const arrayField of arrayFields) {
            if (this[arrayField].length !== other[arrayField].length) {
                return false;
            }

            for (const arrayValue of this[arrayField]) {
                if (other[arrayField].indexOf(arrayValue) === -1) {
                    return false;
                }
            }
        }

        return true;
    }

    public toMonitoringKeywordGroupModel(): MonitoringKeywordGroupModel {
        const keywordGroup = new MonitoringKeywordGroupModel();
        keywordGroup.and = this.and.slice();
        keywordGroup.or = this.or.slice();
        keywordGroup.not = this.not.slice();
        return keywordGroup;
    }

    /**
    * Constructs the model from the corresponding API entity
    */
    private constructFromApiEntity(apiEntity: MediaSubscriptionKeywordApi): void {
        this.and = apiEntity.mustTerms;
        this.or = apiEntity.shouldTerms;
        this.not = apiEntity.mustNotTerms;

        if (apiEntity.mediaTypeRequests?.length && !apiEntity.isAgent) {
        // for tv and radio media types, they do not have handles
        // for others, AM subscription only has 1 mediaType defined in mediaTypeRequests
            this.handles = apiEntity.mediaTypeRequests[0].handles;
        }

        // MediaSubscriptionApi.handles is deprecated, but if handles cannot be found in mediaTypeRequests
        // fall back to handles for back compatibility
        if (!this.handles?.length) {
            this.handles = apiEntity.handles || [];
            if (apiEntity.mediaTypeRequests?.length && !apiEntity.isAgent) {
                apiEntity.mediaTypeRequests[0].handles = this.handles?.slice();
            }
        }
    }

    /**
    * Constructs the default version of the model
    */
    private constructDefault(): void {
        this.and = [];
        this.or = [];
        this.not = [];
        this.handles = [];
    }

    /**
    * Sets the keyword validation tests for this model
    */
    protected setKeywordValidations(): void {
        // Subscription keyword validations do not
        // need to include wildcard based tests

        this.keywordValidations = [
            this.characterLimit,
            this.mustNotBeOperator,
            this.onlyPermittedCharacters,
            this.mustNotStartWithHyphen,
        ];
    }

    /**
    * Checks if the provided list of keywords
    * exists and is populated
    */
    private hasKeywordsOfType(keywords: string[]): boolean {
        const hasKeywordsOfType: boolean = Array.isArray(keywords) && keywords.length > 0;

        return hasKeywordsOfType;
    }
}
